import { Application } from '@hotwired/stimulus'
import { Autocomplete } from 'stimulus-autocomplete'
import NestedForm from "stimulus-rails-nested-form"
import CheckboxSelectAll from "stimulus-checkbox-select-all"


const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

application.register('autocomplete', Autocomplete)
application.register('nested-form', NestedForm)
application.register("checkbox-select-all", CheckboxSelectAll)

export { application }
